export default {
  common: {
    loading: 'Загрузка...',
    loading_short: '...',
    saving: 'Сохранение...',
    saving_short: '...',
    save: 'Сохранить',
    add: 'Добавить',
    cancel: 'Отмена',
    edit: 'Изменить',
    delete: 'Удалить',
    close: 'Закрыть',
    back: '← Назад',
    refresh: 'Обновить',
    update: 'Обновить',
    all: 'Все',
    name: 'Название',
    description: 'Описание',
    link: 'Ссылка',
    date: 'Дата',
    month: 'Месяц',
    slug: 'slug',
    error: 'Ошибка',
    select_placeholder: 'Выберите...',
    url_placeholder: 'https://...',
    copy: 'Копировать',
    copy_link: 'Копировать ссылку',
    copied: 'Скопировано',
    copy_failed: 'Не удалось скопировать',
    edit_title: 'Редактировать',
    save_error: 'Ошибка сохранения',
    delete_error: 'Ошибка удаления',
    details: 'Подробнее',
    hide: 'Скрыть',
    generating: '{label}...',
    files_count: '{count} файл(ов) · {date}',
  },

  nav: {
    brand: 'SMM Admin',
    home: 'Главная',
    smm: 'SMM',
    logout: 'Выйти',
  },

  auth: {
    brand: 'Vue Laravel SPA',
    login: {
      email: 'Email',
      password: 'Пароль',
      remember_me: 'Запомнить меня',
      forgot_password: 'Забыли пароль?',
      submit: 'Войти',
      submitting: 'Вход…',
      show_password: 'Показать',
      hide_password: 'Скрыть',
      no_account: 'Ещё нет аккаунта?',
      sign_up: 'Зарегистрироваться',
    },
    register: {
      name: 'Имя',
      email: 'Email',
      password: 'Пароль',
      password_confirmation: 'Повторите пароль',
      submit: 'Регистрация',
    },
    forgot_password: {
      email: 'Email',
      submit: 'Отправить письмо для сброса пароля',
    },
    reset_password: {
      email: 'Email',
      password: 'Пароль',
      password_confirmation: 'Подтверждение пароля',
      submit: 'Сбросить пароль',
    },
    confirm_password: {
      title: 'Подтвердите пароль',
      description:
        'Для выполнения действия нужно подтвердить пароль. После подтверждения можно повторить операцию.',
      password: 'Пароль',
      submit: 'Подтвердить',
    },
    verify_email: {
      title: 'Подтверждение email',
      description:
        'Спасибо за регистрацию! Подтвердите email, перейдя по ссылке из письма. Если письма нет — отправим ещё раз.',
      resend: 'Отправить письмо повторно',
    },
    two_factor_challenge: {
      code: 'Код двухфакторной аутентификации',
      submit: 'Войти',
    },
  },

  home: {
    welcome: 'Добро пожаловать в Vue SPA на Laravel.',
  },

  errors: {
    not_found: 'Страница не найдена',
    auth_required: 'Нужно войти в систему',
  },

  user: {
    profile: {
      section_title: 'Профиль',
      section_description: 'Обновите имя и email вашего аккаунта.',
      name: 'Имя',
      email: 'Email',
    },
    password: {
      section_title: 'Пароль',
      section_description: 'Используйте длинный случайный пароль для безопасности.',
      current: 'Текущий пароль',
      new: 'Новый пароль',
      confirmation: 'Подтверждение пароля',
    },
    two_factor: {
      section_title: 'Двухфакторная аутентификация',
      section_description: 'Дополнительная защита аккаунта с помощью 2FA.',
      enabled: 'Двухфакторная аутентификация включена.',
      disabled: 'Двухфакторная аутентификация не включена.',
      description:
        'При включённой 2FA при входе потребуется код из приложения Google Authenticator.',
      setup_key: 'Ключ настройки:',
      activate_instruction:
        'Для активации 2FA отсканируйте QR-код и введите первый TOTP-код.',
      code: 'Код 2FA',
      activate_submit: 'Активировать 2FA',
      activate: 'Активировать',
      show_recovery_codes: 'Показать коды восстановления',
      reset_recovery_codes: 'Сбросить коды восстановления',
      deactivate: 'Отключить',
      deactivate_confirm: 'Отключить двухфакторную аутентификацию?',
    },
  },

  smm: {
    nav: {
      networks: 'Соцсети',
      schedule: 'Расписание',
      content: 'Контент',
      kanban: 'Канбан',
      board: 'Доска',
      settings: 'Settings',
      marketing_plans: 'Маркетинг',
      today: 'Сегодня',
      stats: 'Стата',
    },
    common: {
      social_network: 'Соцсеть',
    },
    prompt_kind: {
      schedule: 'Расписание',
      post_image: 'Картинка поста',
      post_video: 'Видео поста',
      custom: 'Другое',
    },
    status: {
      backlog: 'Бэклог',
      todo: 'К созданию',
      in_progress: 'В работе',
      review: 'Проверка',
      done: 'Готово',
    },
    content_kind: {
      video: 'YouTube видео',
      masterclass: 'Мастеркласс Etsy',
      content: 'Контент',
    },
    networks: {
      title: 'Соцсети',
      subtitle: 'Каналы SMM: промпты, расписание, контент',
      add: 'Добавить соцсеть',
      empty: 'Нет соцсетей. Добавьте Pinterest или другую площадку.',
      badge_api: 'API',
      badge_inactive: 'выкл.',
      stats: 'Промптов: {prompts} · Задач: {tasks} · Идей: {ideas}',
      new_title: 'Новая соцсеть',
      slug: 'Slug (URL)',
      slug_placeholder: 'pinterest',
      profile_url: 'Ссылка на профиль',
      profile_url_placeholder: 'https://...',
      username: 'Юзернейм',
      password_hint: 'Напоминалка пароля',
      password_hint_help: 'Не настоящий пароль — текст, чтобы вспомнить его.',
      followers_count: 'Подписчики',
      followers_label: '{count} подписчиков',
      has_api: 'Есть API (заглушка интеграции)',
      is_active: 'Активна',
      base_prompt: 'Основной промпт',
      base_prompt_placeholder: 'Основные инструкции для этой соцсети (тон, аудитория, правила)…',
      base_prompt_help: 'Добавляется к AI-генерации для этой сети. Если заполнено — имеет приоритет над шаблоном «prefix».',
      base_prompt_ready: 'Основной промпт заполнен',
      shop: 'Канал продаж',
      shop_none: 'Не выбран',
      platform: 'Тип соцсети',
      platform_none: 'Не выбран',
      platforms: {
        instagram: 'Instagram',
        pinterest: 'Pinterest',
        etsy: 'Etsy',
        youtube: 'YouTube',
        threads: 'Threads',
        facebook: 'Facebook',
      },
      load_error: 'Не удалось загрузить соцсети',
      delete_confirm: 'Удалить «{name}»?',
    },
    ideas: {
      open: 'Идеи',
      title: 'Идеи',
      subtitle: 'Креативные идеи для этой сети — потом используются при генерации расписания.',
      count: 'Идей: {n}',
      add: 'Добавить идею',
      empty: 'Идей пока нет. Добавьте первую.',
      select_or_add: 'Выберите идею слева или нажмите «Добавить идею».',
      new_title: 'Новая идея',
      edit_title: 'Редактирование идеи',
      untitled: 'Идея без названия',
      field_title: 'Заголовок',
      field_title_placeholder: 'Короткая метка (необязательно)',
      field_body: 'Описание',
      field_body_placeholder: 'В чём идея? Тон, хук, угол…',
      images: 'Картинки',
      paste_hint: 'Вставьте картинку сюда (Ctrl+V) или перетащите файлы',
      paste_manual_hint: 'Скопируйте картинку, кликните в зону вставки и нажмите Ctrl+V',
      files: 'Вложения',
      attach_files: 'Прикрепить файлы',
      files_empty: 'Некартиночных файлов пока нет.',
      files_count: 'Файлов: {n}',
      saved: 'сохр.',
      delete_confirm: 'Удалить эту идею и её файлы?',
    },
    network_detail: {
      back: '← Соцсети',
      prompts_title: 'Промпты',
      add_prompt: 'Добавить промпт',
      prompts_empty: 'Нет промптов. Добавьте «Расписание постов», «Создание картинки поста» и т.д.',
      prefix_hint:
        'Автоматически добавляется в начало любого промпта для AI. Не выбирается вручную.',
      schema_summary: 'JSON-схема ответа',
      generate_schedule: 'Сгенерировать расписание',
      edit_prompt: 'Редактировать промпт',
      new_prompt: 'Новый промпт',
      prompt_body_placeholder: 'Текст промпта + инструкция про JSON',
      schema_label: 'JSON-схема ответа (объект)',
      schema_placeholder: '{"caption": "string", "hashtags": []}',
      invalid_schema: 'Некорректный JSON в схеме',
      delete_prompt_confirm: 'Удалить промпт «{name}»?',
      schedule_created:
        'Расписание создано: {days} дней, {pins} пинов. Откройте «Расписание» (режим Месяц).',
      schedule_created_at: 'Создано: {when}',
      overwrite_confirm: 'Перезаписать расписание новым результатом?',
      generate_error: 'Ошибка генерации',
    },
    schedule: {
      title: 'Расписание',
      view_mode: 'Режим',
      mode_month: 'Месяц',
      mode_day: 'Один день',
      month_description:
        'Обзор месяца: в каждом дне может быть несколько вариантов пинов. Клик по пину — генерация контента.',
      day_description: 'Слоты на {date}',
      stats: 'Дней: {days} · Пинов: {pins}',
      empty_day: 'На этот день нет записей.',
      empty_month: 'Нет дней на этот месяц.',
      empty_hint: 'Сгенерируйте расписание в карточке соцсети.',
      pin: 'нет пинов | {n} пин | {n} пина | {n} пинов',
      slot_error: 'Не удалось определить слот расписания',
      open_error:
        'Не удалось открыть слот. Проверьте, что выполнена миграция БД (php artisan migrate).',
      resolve_error: 'Не удалось подобрать контент',
      max_images: 'Можно выбрать не более 5 изображений для промпта.',
      min_images: 'Нужно выбрать хотя бы одно изображение.',
      files_update_error: 'Не удалось обновить выбор файлов',
      pin_published: 'Пин опубликован',
      publish_error: 'Ошибка публикации',
    },
    schedule_modal: {
      tab_content: 'Контент',
      tab_logs: 'Логи',
      matched_content: 'Подобранный контент',
      resolving: 'Подбор...',
      rematch: 'Подобрать заново',
      searching: 'Ищем совпадение в библиотеке...',
      match_fuzzy: 'похожее совпадение',
      match_exact: 'точное совпадение',
      library_description: 'Описание из библиотеки (уходит в промпт)',
      video_label: 'Видео · {name}',
      no_images: 'Нет изображений у записи контента',
      photo_selection_hint: 'Фото для промпта (до 5): {n}/5 — клик переключает выбор',
      video_hint: 'Видео (не отправляется как референс-картинка):',
      no_match:
        'Не удалось найти подходящий контент. Добавьте материалы на странице «Контент» или нажмите «Подобрать заново».',
      generated_pin: 'Сгенерированный пин',
      ai_json: 'Ответ AI (JSON)',
      published: 'Опубликовано в Pinterest · {date}',
      prompt: 'Промпт',
      extra_photos: 'Доп. фото для промпта',
      extra_photos_hint: 'До 5 изображений суммарно с выбранными из библиотеки',
      notes: 'Заметки',
      pinterest: 'Pinterest',
      link_placeholder: 'Ссылка на товар или видео',
      default_board: 'Доска по умолчанию',
      publishing: 'Публикация...',
      publish: 'Опубликовать в Pinterest',
      generate: 'Сгенерировать контент',
    },
    kanban: {
      click_hint: 'Клик → следующий статус',
    },
    board: {
      project: 'Проект',
      create_ticket: 'Новый тикет',
      no_projects: 'Проектов пока нет.',
      go_settings: 'Настроить в Settings',
      ticket_title: 'Название',
      status: 'Статус',
      type: 'Тип',
      priority: 'Приоритет',
      priority_low: 'Низкий',
      priority_medium: 'Средний',
      priority_high: 'Высокий',
      priority_urgent: 'Срочный',
      due_date: 'Дедлайн',
      due_short: 'До',
      description: 'Описание',
      description_placeholder: 'Что нужно сделать…',
      sections: 'Секции',
      sections_empty: 'Секций нет. Добавьте шаблоны в Settings → Board.',
      section_placeholder: 'Пишите здесь…',
      attachments: 'Вложения',
      attachments_empty: 'Файлов пока нет',
      attachments_drop_hint: 'Перетащите файлы сюда или вставьте картинку (Ctrl+V)',
      attachments_paste_hint: 'Кликните по зоне и нажмите Ctrl+V или разрешите доступ к буферу',
      upload: 'Загрузить',
      comments: 'Комментарии',
      comments_empty: 'Комментариев пока нет',
      comment_placeholder: 'Добавить комментарий…',
      comment_add: 'Отправить',
      anonymous: 'Пользователь',
      delete_confirm: 'Удалить этот тикет?',
      links: 'Ссылки',
      links_empty: 'Ссылок пока нет',
      link_add: 'Добавить',
      link_title_placeholder: 'Подпись (необязательно)',
      link_url_placeholder: 'https://… или любая ссылка',
      linked_tickets: 'Связанные тикеты',
      linked_tickets_empty: 'Связанных тикетов нет',
      linked_search_placeholder: 'Поиск тикета по названию или #id…',
    },
    media: {
      title: 'Контент',
      subtitle: 'Библиотека материалов для Pinterest, Instagram и других площадок',
      tab_published: 'Published',
      tab_generated: 'Generated',
      youtube_import: 'YouTube канал',
      etsy_import: 'Etsy товар',
      add: 'Добавить контент',
      empty: 'Нет медиа. Добавьте первый материал с картинками или видео.',
      empty_shop: 'Для этого магазина пока нет контента.',
      mp4_badge: 'MP4',
      play: 'Воспроизвести',
      video: 'Видео',
      edit_title: 'Редактировать медиа',
      new_title: 'Новый медиа контент',
      files: 'Файлы',
      short_description: 'Краткое описание',
      load_error: 'Не удалось загрузить медиа',
      files_required: 'Добавьте хотя бы один файл (картинку или MP4)',
      delete_file_confirm: 'Удалить этот файл?',
      delete_confirm: 'Удалить «{title}» и все файлы?',
      shop: 'Магазин',
      shop_required: 'Выберите магазин',
      shops_missing: 'Магазины не найдены. Выполните миграцию на сервере.',
      filter_all: 'Все',
      filter_unknown: 'Unknown',
      media_count: '{n} медиа',
      tags_count: '{n} тегов',
      open_product: 'Открыть товар',
      no_shop: 'Без магазина',
      select_all: 'Выбрать всё',
      deselect_all: 'Снять выделение',
      with_selected: 'С выделенными',
      batch_activate: 'Активировать',
      batch_deactivate: 'Деактивировать',
      batch_delete: 'Удалить',
      batch_assign_shop: 'Назначить магазин',
      batch_assign_shop_prompt: 'Выберите магазин',
      batch_none: 'Выберите хотя бы один элемент',
      batch_delete_confirm: 'Удалить выбранные ({n})?',
      inactive_badge: 'Выкл.',
      loading_more: 'Загрузка...',
      tags: 'Теги',
      tags_empty: 'Нет тегов',
      tags_placeholder: 'Название тега или выбор из списка',
      tag_add: 'Добавить',
      tag_create_error: 'Не удалось создать тег',
      list_stats: 'Выбрано: {selected} · Показано: {shown} из {total}',
      search_placeholder: 'Поиск по названию, описанию или тегам…',
      search_button: 'Найти',
      tags_generate: 'Сгенерировать теги',
      tags_generate_quick: 'Сгенерировать и привязать теги',
      tags_generating: 'Генерация…',
      tags_generate_error: 'Не удалось сгенерировать теги',
      tags_generate_empty: 'Новых тегов нет',
      tags_preview_title: 'Предложенные теги',
      tags_preview_hint: 'Снимите лишние, затем примените или отмените.',
      tags_preview_apply: 'Применить выбранные',
      tags_preview_cancel: 'Отмена',
      tab_main: 'Основное',
      tab_media: 'Медиа',
      is_active: 'Активна',
      preview_empty: 'Медиа пока нет',
      files_drag_hint: 'Перетаскивайте плитки, чтобы изменить порядок. Первая используется как превью.',
      files_reorder_error: 'Не удалось сохранить порядок медиа',
      batch_save_images: 'Сохранить картинки на устройство',
      save_images_selected: 'В галерею ({n})',
      save_images_busy: 'Подготовка…',
      save_images_none: 'Нет картинок для сохранения',
      save_images_error: 'Не удалось сохранить. На iPhone: Поделиться → Сохранить изображение.',
    },
    upload: {
      tile_title: 'Выбрать файл, перетащить или Ctrl+V',
      paste_clipboard: 'Вставить из буфера',
      add: 'Добавить',
      ctrl_v_hint: 'Ctrl+V',
      play: 'Воспроизвести',
      select_files: 'Выбрать с компьютера',
      paste_zone_title: 'Зона вставки картинки',
      paste_zone_instruction: 'Скопируйте изображение, нажмите сюда и Ctrl+V',
      paste_ready: 'Готово — нажмите Ctrl+V',
      convert_png_error: 'Не удалось преобразовать «{name}» в PNG',
      browser_open_error: 'Браузер не может открыть «{name}». Сохраните как JPEG или PNG.',
      mp4_only: '«{name}»: поддерживается только MP4',
      image_or_mp4: '«{name}»: нужна картинка или MP4',
      add_error: 'Ошибка добавления файла',
      paste_hint_compact: 'Скопируйте картинку и нажмите Ctrl+V на плитке «+»',
      paste_hint_full: 'Скопируйте картинку, затем нажмите в зону выше и Ctrl+V',
    },
    ai_logs: {
      title: 'Логи AI',
      empty: 'Пока нет запросов',
      type_schedule: 'Расписание',
      type_post_content: 'Контент поста',
      prefix_applied: 'Префикс (slug prefix): добавлен',
      catalog_count: 'Каталог контента: {n} записей',
      provider: 'Провайдер: {provider}',
      references: 'Референсы: {files} (в API: {count})',
      references_api: 'Референсов в API: {n}',
      schedule_stats: 'Дней: {days} · пинов: {pins} (в JSON: {items})',
      prompt_summary: 'Промпт (запрос)',
      raw_response: 'Сырой ответ',
      parsed_json: 'Разобранный JSON',
    },
    pinterest: {
      title: 'Pinterest API',
      env_missing: 'Добавьте PINTEREST_CLIENT_ID и PINTEREST_CLIENT_SECRET в .env',
      connected: 'Подключено: @{username}',
      not_connected: 'Не подключено — нужен OAuth',
      disconnect: 'Отключить',
      connect: 'Подключить Pinterest',
      default_board: 'Доска по умолчанию',
      select_board: 'Выберите доску...',
      redirect_uri: 'Redirect URI в Pinterest: {uri}',
      connect_error: 'Ошибка подключения',
      disconnect_confirm: 'Отключить Pinterest?',
      board_saved: 'Доска сохранена',
      connected_success: 'Pinterest успешно подключён',
    },
    youtube: {
      title: 'Импорт видео с YouTube',
      description:
        'Каждое видео сохраняется как отдельная запись контента (название, ссылка, описание, превью-картинка).',
      tab_channel: 'Канал',
      tab_urls: 'Ссылки на видео',
      channel_url: 'Ссылка на YouTube канал',
      channel_placeholder: 'https://www.youtube.com/@your-channel',
      channel_hint:
        'Поддерживаются @handle, /channel/UC…, /c/… и /user/…. С API-ключом загружаются все видео, без ключа — последние ~15 через RSS.',
      urls_label: 'Ссылки на видео (по одной на строку)',
      urls_placeholder: 'https://www.youtube.com/watch?v=...\nhttps://youtu.be/...',
      urls_hint:
        'Альтернатива, если импорт канала недоступен. Описания подтягиваются со страниц видео.',
      load_list: 'Загрузить список',
      channel_preview: 'Канал: {title} · {n} видео',
      select_all: 'Выбрать все ({selected}/{total})',
      no_description: 'Без описания',
      no_videos: 'Видео не найдены.',
      import: 'Импортировать ({n})',
      api_key_hint: 'Попробуйте вкладку «Ссылки на видео» или добавьте YOUTUBE_API_KEY в .env',
      select_required: 'Выберите хотя бы одно видео',
    },
    etsy: {
      title: 'Добавить товар Etsy',
      tab_url: 'По URL',
      tab_html: 'Вставить HTML',
      url_label: 'URL товара на Etsy',
      url_placeholder: 'https://www.etsy.com/listing/123456789/...',
      html_label: 'HTML страницы',
      html_hint:
        'Откройте товар на Etsy → Ctrl+U (исходный код) → Ctrl+A → Ctrl+C → вставьте сюда. Используйте, если сервер получает HTTP 403.',
      html_placeholder: '<!DOCTYPE html>...',
      parse: 'Спарсить',
      images_count: 'Картинки ({n})',
      videos_count: 'Видео ({n})',
      image_alt: 'Изображение {n}',
      api_key_hint: 'Переключитесь на «Вставить HTML» или добавьте ETSY_API_KEY в .env',
      no_images: 'Нет картинок для сохранения',
    },
    settings: {
      menu_channels: 'Каналы продаж',
      menu_prompts: 'Промпты',
      channels_title: 'Каналы продаж',
      channels_subtitle: 'Магазины и каналы из фильтров контента',
      channels_empty: 'Каналов пока нет. Добавьте первый.',
      channel_add: 'Добавить канал',
      channel_select: 'Выберите канал слева',
      channel_delete_confirm: 'Удалить канал «{name}»?',
      slug: 'Системный slug',
      color: 'Цвет',
      homepage_url: 'Ссылка на главную',
      base_prompt: 'Базовый промпт',
      base_prompt_placeholder: 'Краткое описание канала продаж для AI и публикаций…',
      media: 'Медиафайлы',
      media_hint: 'Перетаскивайте для сортировки. Как у медиа контента.',
      is_active: 'Активен',
      inactive: 'выкл.',
      reorder_error: 'Не удалось сохранить порядок медиа',
      prompts_title: 'Системные промпты',
      prompts_subtitle: 'Глобальные промпты по типу. Удалить нельзя — только редактировать.',
      prompts_empty: 'Промптов пока нет.',
      prompt_select: 'Выберите промпт слева',
      prompt_slug: 'Тип (slug)',
      prompt_slug_locked: 'Уникальный тип. Нельзя изменить или удалить.',
      prompt_description: 'Описание',
      prompt_body: 'Текст промпта',
      prompt_body_placeholder: 'Текст, который используется при генерации…',
      menu_campaigns: 'Campaigns',
      campaigns_title: 'Campaigns',
      campaigns_subtitle: 'Сезонные и тематические события: Back to school, Christmas и т.п.',
      campaigns_empty: 'Кампаний пока нет. Добавьте первую.',
      campaign_add: 'Добавить кампанию',
      campaign_select: 'Выберите кампанию слева',
      campaign_delete_confirm: 'Удалить кампанию «{name}»?',
      campaign_starts_on: 'Дата начала',
      campaign_ends_on: 'Дата окончания',
      campaign_ends_on_optional: 'Необязательно',
      campaign_description: 'Описание события',
      campaign_description_placeholder: 'Что за событие, какие темы и акценты учитывать в контенте…',
      campaign_priority: 'Приоритет (1–10)',
      menu_platforms: 'Платформы',
      platforms_title: 'Платформы',
      platforms_subtitle: 'Соцплощадки и их AI output schema (metadata / content / platform_specific).',
      platforms_empty: 'Платформ пока нет. Добавьте первую.',
      platform_add: 'Добавить платформу',
      platform_select: 'Выберите платформу слева',
      platform_delete_confirm: 'Удалить платформу «{name}»?',
      platform_slug: 'Slug',
      platform_sort_order: 'Порядок',
      platform_output_schema: 'Output schema (JSON)',
      platform_output_schema_help: 'JSON Schema, которую использует Generate Content для этой площадки.',
      platform_schema_invalid: 'Output schema должна быть валидным JSON-объектом.',
      menu_business: 'Business context',
      business_title: 'Business context',
      business_subtitle: 'Глобальный контекст компании для AI-агентов',
      business_company: 'Компания',
      business_hours: 'Часов в неделю на продакшн',
      business_timezone: 'Таймзона',
      business_language: 'Язык',
      business_currency: 'Валюта',
      business_notes: 'Заметки',
      menu_board: 'Доска',
      board_title: 'Доска',
      board_subtitle: 'Проекты, статусы (дорожки), типы тикетов и шаблоны секций',
      board_tab_projects: 'Проекты',
      board_tab_statuses: 'Статусы',
      board_tab_types: 'Типы',
      board_tab_sections: 'Секции',
      board_empty: 'Пока пусто. Добавьте первый элемент.',
      board_add: 'Добавить',
      board_select: 'Выберите элемент слева',
      board_delete_confirm: 'Удалить «{name}»?',
      board_is_done: 'Статус «готово»',
      board_field_type: 'Тип поля',
      sort_order: 'Порядок',
      menu_logs: 'Logs',
    },
    logs: {
      title: 'Logs',
      subtitle: 'AI и SMM-логи с пагинацией. Полные промпты открываются отдельно.',
      empty: 'Логов пока нет.',
      source_all: 'Все источники',
      source_smm_ai: 'smm-ai.log',
      source_laravel: 'laravel (SMM)',
      source_prompts: 'Файлы промптов',
      level_all: 'Все уровни',
      search_placeholder: 'Поиск по тексту…',
      search: 'Найти',
      open: 'Открыть',
      show_context: 'Контекст',
      page_of: 'Стр. {page} / {pages} · всего {total}',
    },
    marketing_plans: {
      title: 'Маркетинг планы',
      subtitle: 'Этап 1: стратегия месяца через Marketing Director AI',
      empty: 'Планов пока нет. Сгенерируйте первый.',
      generate: 'Generate Marketing Plan',
      generate_schedule: 'Generate Schedule',
      open_today: 'Today workspace',
      tasks_count: 'задач: {n}',
      platform_targets: 'Цели по площадкам',
      priority_products: 'Приоритетные продукты',
      schedule_confirm: 'Сгенерировать очередь задач по этому плану? Плановые задачи будут заменены. Генерация идёт по неделям и может занять несколько минут.',
      schedule_done: 'Создано задач: {n} (цель плана ≈ {target}, AI вернул {parsed})',
      status: {
        draft: 'черновик',
        generating: 'генерация',
        completed: 'готов',
        active: 'активен',
        archived: 'архив',
      },
    },
    today: {
      title: 'Today’s Workspace',
      subtitle: 'Задачи на {date}',
      empty: 'На этот день задач нет. Сначала сгенерируйте Marketing Plan и Schedule.',
      go_today: 'Сегодня',
      prev_day: 'Предыдущий день',
      next_day: 'Следующий день',
      no_product: 'Без продукта',
      no_photo: 'Нет фото',
      product: 'Продукт',
      open_listing: 'Открыть листинг',
      angle: 'Creative Goal / Concept',
      brief: 'Бриф',
      selected_photos: 'Выбрано фото',
      pick_photos: 'Фото продукта',
      pick_photos_hint: 'Выберите 1–4 фото — они уйдут в AI вместе с Generate Content.',
      clear_selection: 'Сбросить',
      no_product_photos: 'У продукта пока нет фото. Загрузите их в Media.',
      max_photos: 'Можно выбрать не больше {n} фото.',
      media_description: 'Описание медиа',
      media_description_placeholder: 'Что сняли / показали на видео или фото…',
      generate_content: 'Generate Content',
      publish: 'Publish',
      publish_confirm: 'Отметить задачу как опубликованную?',
      generated: 'Сгенерированный контент',
      envelope: {
        metadata: 'Metadata',
        data: 'Data',
        content: 'Content',
        platform_specific: 'Platform-specific',
      },
      status: {
        planned: 'planned',
        media_ready: 'media ready',
        content_generated: 'generated',
        published: 'published',
        skipped: 'skipped',
      },
    },
    stats: {
      title: 'Статистика продаж Etsy',
      subtitle: 'Заказы из писем Etsy. Кнопка каждый раз подтягивает небольшую порцию с Gmail.',
      import_now: 'Загрузить порцию',
      import_account: '{shop} — загрузить порцию',
      importing: 'Загрузка порции (~1 мин)…',
      import_queued: 'Импорт запущен в фоне, ждём результат…',
      import_poll_timeout: 'Импорт всё ещё идёт или завис. Проверьте SSH/cron или лог storage/logs/etsy-import-bg.log',
      import_next_hint: 'Готово. Offset {skip} — нажмите ещё раз за следующие {batch} писем.',
      import_result: 'Просмотрено {scanned}, импортировано {imported}, пропущено {skipped}, ошибок {failed}.',
      import_result_account: '{shop}: просмотрено {scanned}, импортировано {imported}, пропущено {skipped}, ошибок {failed}.',
      import_mailbox_total: 'В ящике {n} писем Etsy; в базе сейчас {db} заказов.',
      mail_counts: 'В базе: {db} заказов. В почте (transaction@etsy.com): {mailbox}.',
      mail_counts_account: 'В базе: {db} заказов. Ящик {shop}: {mailbox} писем.',
      mail_counts_db_only: 'В базе: {db} заказов.',
      all_shops: 'Все магазины',
      orders: 'Заказы',
      revenue: 'Выручка',
      timezone: 'Таймзона',
      period: 'Период',
      group_by: 'Группировать',
      group_monthly: 'Помесячно',
      group_all_time: 'За всё время',
      month_prev: 'Предыдущий месяц',
      month_next: 'Следующий месяц',
      discounted_orders: 'Со скидкой',
      discounted_orders_short: 'Со скидкой',
      full_price_orders: 'Полная цена',
      avg_discount_pct: 'Ср. скидка (среди скидочных)',
      avg_discount_pct_short: 'Ср. скидка',
      avg_discount_pct_hint: 'Только заказы со скидкой',
      discount_rate: 'Discount Rate',
      discount_rate_short: 'Disc. rate',
      discount_rate_hint: 'Σ скидок / Σ цены без скидки',
      discount_sum: 'Сумма скидок',
      original_sum: 'Без скидки',
      pricing_partial: 'Цены/скидки известны для {n} из {total} заказов — нажмите загрузку почты ещё раз, чтобы догрузить.',
      import_updated: 'Обновлено скидок: {n}.',
      weekday_col: 'День',
      by_hour: 'Продажи по часам',
      by_day: 'Заказы по дням',
      by_day_of_month: 'Заказы по числу месяца (за всё время)',
      by_day_hint: 'Сравнение начала и конца месяца — зелёный 1–10, синий 11–20, фиолетовый 21–31',
      day_n: 'День {n}',
      avg_orders_per_day: 'Среднее число заказов в день',
      avg_orders_overall: 'За весь период',
      avg_orders_days: '{n} дн.',
      month_phase: {
        start: 'Начало месяца',
        middle: 'Середина',
        end: 'Конец месяца',
      },
      by_time_of_day: 'Время суток',
      by_weekday: 'День недели',
      top_products: 'Топ товаров',
      by_promo: 'Промокоды',
      promo_code: 'Промокод',
      promo_none: 'Без промокода',
      promo_discount_pct: 'Скидка %',
      product: 'Товар',
      units: 'Шт.',
      name_variants: 'Склеены {n} варианта названия',
      empty: 'Пока нет продаж. Нажмите «Загрузить всё из почты» — подтянутся все confirmation с Gmail.',
      mail_not_configured: 'Почта не настроена. Укажите DIY_ETSY_MAIL_USERNAME / DIY_ETSY_MAIL_PASSWORD (и при необходимости BSS_…) в .env (для Gmail — App Password).',
      mail_account_not_configured: 'Для «{account}» не заданы логин/пароль в .env.',
      mail_imap_missing: 'Выключено PHP-расширение imap. В php.ini включите extension=imap и перезапустите PHP.',
      mail_imap_blocked: 'Хостинг блокирует исходящий IMAP (порт 993 к Gmail). Кнопка импорта с сайта работать не будет, пока хостинг не откроет 993 — либо импортируйте с ПК в прод-БД через artisan.',
      import_empty_hint: 'Новых писем нет (всё уже в базе) или в ящике ничего не найдено.',
      import_done: 'Достигнут конец ящика — новых писем от transaction@etsy.com нет.',
      import_fast_done: 'Всё актуально: в базе {db}, в ящике {mailbox}. Новых писем нет.',
      import_fast_done_account: '{shop}: всё актуально (в базе {db}, в ящике {mailbox}). Новых писем нет.',
      import_zero_hint: 'В этой порции новых заказов нет (просмотрено {examined}, уже в базе {already}). Жмите ещё раз — поиск продолжится дальше.',
      tod: {
        night: 'Ночь (0–5)',
        morning: 'Утро (6–11)',
        afternoon: 'День (12–17)',
        evening: 'Вечер (18–23)',
      },
      weekday: {
        sun: 'Воскресенье',
        mon: 'Понедельник',
        tue: 'Вторник',
        wed: 'Среда',
        thu: 'Четверг',
        fri: 'Пятница',
        sat: 'Суббота',
      },
    },
    etsyGen: {
      panel_title: 'Сгенерированные листинги',
      panel_subtitle: 'Генерация данных Etsy-листинга с помощью AI.',
      panel_empty: 'Пока ничего не сгенерировано. Нажмите «New Etsy listing», чтобы начать.',
      new_listing: 'New Etsy listing',
      title: 'Новый Etsy-листинг',
      subtitle: 'Выберите Etsy-магазин, добавьте фото и короткое описание — AI напишет название, описание и теги.',
      network: 'Etsy-магазин (соцсеть)',
      no_networks: 'Нет соцсетей с платформой «Etsy». Добавьте их в разделе Networks.',
      photos: 'Фото (до 5)',
      add_photo: 'Добавить',
      description: 'Короткое описание',
      description_placeholder: 'Что это за изделие? Материалы, размер, стиль, повод…',
      generate: 'Сгенерировать данные',
      generating: 'Генерация…',
      result_hint: 'Данные листинга сгенерированы. Скопируйте нужные поля иконкой и нажмите «Сохранить».',
      saved_hint: 'Сохранено. Листинг доступен на вкладке Generated.',
      save: 'Сохранить листинг',
      raw_json: 'Исходный JSON',
      back_to_form: 'Назад',
      list_untitled: 'Листинг без названия',
      open: 'Открыть',
      delete_confirm: 'Удалить этот сгенерированный листинг?',
    },
  },
}
